import React, { useEffect, useState } from "react";
import { gameStatuses } from "../../pages/FingersBattlePage";

const CountDownTimer = ({ hoursMinSecs, handleGameEnded, gameStatus }) => {
  const { hours = 0, minutes = 0, seconds = 0 } = hoursMinSecs;
  const [[hrs, mins, secs], setTime] = React.useState([
    hours,
    minutes,
    seconds,
  ]);
  const [timerBg, settimerBg] = useState("bg-blue-400");

  const tick = () => {
    if (hrs === 0 && mins === 0 && secs === 0) {
    } else if (mins === 0 && secs === 0) {
      setTime([hrs - 1, 59, 59]);
    } else if (secs === 0) {
      setTime([hrs, mins - 1, 59]);
    } else {
      setTime([hrs, mins, secs - 1]);
    }
  };

  const reset = () => setTime([parseInt(0), parseInt(0), parseInt(15)]);

  React.useEffect(() => {
    if (mins === 0 && secs < 30) {
      settimerBg("bg-red-400");
    }

    if (secs === 0) {
      handleGameEnded();
    }

    const timerId = setInterval(() => tick(), 1000);
    return () => clearInterval(timerId);
    // eslint-disable-next-line
  }, [secs]);

  useEffect(() => {
    if (secs === 0 && gameStatus === gameStatuses.PLAYING) {
      reset();
    }
    //eslint-disable-next-line
  }, [gameStatus]);
  return (
    <div className="flex flex-row gap-2 justify-center">
      <div
        className={
          "md:h-11 md:w-11 lg:h-11 lg:w-11 h-8 w-8 justify-center flex items-center rounded font-bold text-white  " +
          timerBg
        }
      >
        {mins.toString().padStart(2, "0")}
      </div>
      <div
        className={
          "md:h-11 md:w-11 lg:h-11 lg:w-11 h-8 w-8 justify-center flex items-center rounded font-bold text-white  " +
          timerBg
        }
      >
        {secs.toString().padStart(2, "0")}
      </div>
      {/* <p>{`${hrs.toString().padStart(2, '0')}:${mins
        .toString()
        .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`}</p> */}
    </div>
  );
};

export default CountDownTimer;
